import React from 'react';

function ModalInfoPatient({ patient, onFermer }) {
    if (!patient) return null;

    const champStyle = {
        fontSize: '14px', color: 'var(--text)',
        padding: '10px 14px', background: 'var(--bg)',
        border: '1px solid var(--border)', borderRadius: '8px'
    };

    const labelStyle = {
        fontSize: '11px', color: 'var(--text-muted)', marginBottom: '4px'
    };

    return (
        <div
            onClick = {e => e.target === e.currentTarget && onFermer()}
            style={{
                display: 'flex', position: 'fixed', inset: 0,
                background: 'rgba(0,0,0,0.6)', zIndex: 100,
                alignItems: 'center', justifyContent: 'center'
            }}
        >
            <div style={{
                background: 'var(--bg-light)', border: '1px solid var(--border)',
                padding: '32px', borderRadius: '12px',
                width: '440px', maxWidth: '90vw'
            }}>
                <h3 style={{ fontSize: '16px', fontWeight: 500, color: 'var(--white)', marginBottom: '24px' }}>
                    👤 Informations patient
                </h3>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
                    {/* Prénom + Nom */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                        <div>
                            <div style={labelStyle}>Prénom</div>
                            <div style={champStyle}>{patient.prenom || '—'}</div>
                        </div>
                        <div>
                            <div style={labelStyle}>Nom</div>
                            <div style={champStyle}>{patient.nom || '—'}</div>
                        </div>
                    </div>

                    {/* Âge + Téléphone */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: '12px' }}>
                        <div>
                            <div style={labelStyle}>Âge</div>
                            <div style={champStyle}>{patient.age ? `${patient.age} ans` : '—'}</div>
                        </div>
                        <div>
                            <div style={labelStyle}>Téléphone</div>
                            <div style={champStyle}>{patient.telephone || '—'}</div>
                        </div>
                    </div>

                    {/* Sexe */}
                    <div>
                        <div style={labelStyle}>Sexe</div>
                        <div style={champStyle}>
                            {patient.sexe === 'M' ? '♂ Homme' : patient.sexe === 'F' ? '♀ Femme' : '—'}
                        </div>
                    </div>
                </div>

                {/* Bouton fermer */}
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '24px' }}>
                    <button
                        onClick = {onFermer}
                        style={{
                            padding: '9px 18px', background: 'var(--white)',
                            color: '#1a1a1a', border: 'none',
                            borderRadius: '8px', fontSize: '13px',
                            fontWeight: 500, cursor: 'pointer'
                        }}
                    >Fermer</button>
                </div>
            </div>
        </div>
    );
}

export default ModalInfoPatient;